<template>
  <div :style="input.disabled || input.readonly ? 'pointer-events: none;' : ''">
    <!-- {{input.fullwidth}} -->
    <input
      type="time"
      :class="'form-control ' + input.class"
      :value="value"
      @input="handleChange"
      @context="handleChange"
      @change="handleChange"
      :placeholder="input.placeholder"
      :required="!input.optional"
      :disabled="input.disabled"
      :readonly="input.readonly"
      :name="input.name"
      :style="input.fullwidth ? 'width:100%' : ''"
    />
  </div>
</template>
<script>
export default {
  name: "InputTime",
  components: {},
  props: {
    input: Object,
    value: String,
  },
  data: function() {
    return {};
  },
  methods: {
    handleChange(e) {
      ////console.log(e);
      // e.target={
      //   value:e.selectedYMD,
      //   name:this.input.name
      // }
      this.$emit("handleChange", e);
    },
  },
};
</script>
